/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';

/**
 * 
 * @export
 * @interface OrderBookingInfoDto
 */
export interface OrderBookingInfoDto {
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof OrderBookingInfoDto
     */
    stayDates: TravelineBookingStayDatesDto;
    /**
     * Количество взрослых
     * @type {number}
     * @memberof OrderBookingInfoDto
     */
    adults: number;
    /**
     * Возраст детей
     * @type {Array<number>}
     * @memberof OrderBookingInfoDto
     */
    childAges: Array<number>;
    /**
     * Номер заказа
     * @type {string}
     * @memberof OrderBookingInfoDto
     */
    orderNumber?: string;
}

/**
 * Check if a given object implements the OrderBookingInfoDto interface.
 */
export function instanceOfOrderBookingInfoDto(value: object): value is OrderBookingInfoDto {
    if (!('stayDates' in value) || value['stayDates'] === undefined) return false;
    if (!('adults' in value) || value['adults'] === undefined) return false;
    if (!('childAges' in value) || value['childAges'] === undefined) return false;
    return true;
}

export function OrderBookingInfoDtoFromJSON(json: any): OrderBookingInfoDto {
    return OrderBookingInfoDtoFromJSONTyped(json, false);
}

export function OrderBookingInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBookingInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'stayDates': TravelineBookingStayDatesDtoFromJSON(json['stayDates']),
        'adults': json['adults'],
        'childAges': json['childAges'],
        'orderNumber': json['orderNumber'] == null ? undefined : json['orderNumber'],
    };
}

  export function OrderBookingInfoDtoToJSON(json: any): OrderBookingInfoDto {
      return OrderBookingInfoDtoToJSONTyped(json, false);
  }

  export function OrderBookingInfoDtoToJSONTyped(value?: OrderBookingInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stayDates': TravelineBookingStayDatesDtoToJSON(value['stayDates']),
        'adults': value['adults'],
        'childAges': value['childAges'],
        'orderNumber': value['orderNumber'],
    };
}

